import { DocumentsList } from '@domain/types';
import { EntitiesState } from '@store/entities/entities.state';

/**
 * Transforme entities from API to Redux Entities
 * Should be removed at some point when entities are normalized in the API
 */
export function normalizeEntitiesFromAPI(documentsList: DocumentsList): EntitiesState {
  const { entities } = documentsList;

  const normalized: EntitiesState = {
    Patient: {},
    Practitioner: {},
    Organization: {},
    PractitionerRole: {},
    Attachments: {},
  };

  entities.patients?.forEach((patient) => {
    normalized.Patient[patient.id] = patient;
  });

  entities.practitioners?.forEach((practitioner) => {
    normalized.Practitioner[practitioner.id] = practitioner;
  });

  entities.organizations?.forEach((organization) => {
    normalized.Organization[organization.id] = organization;
  });

  entities.practitionerRoles?.forEach((role) => {
    normalized.PractitionerRole[role.id] = role;
  });

  return normalized;
}
